export const prioritiesDict: { [key: string]: string } = {
  Normal: 'Normal',
  Urgent: 'Urgent',
  'Low-Priority': 'Low-Priority',
};

export const priorities: string[] = Object.keys(prioritiesDict).map(
  k => prioritiesDict[k]
);
